import afterEach from './afterEach'
import beforeEach from './beforeEach'
import router from './router'

beforeEach.forEach(before => router.beforeEach(before))
afterEach.forEach(after => router.afterEach(after))

export default router
